import { render, staticRenderFns } from "./wxyuceReport-goods.vue?vue&type=template&id=46703a6d&"
import script from "./wxyuceReport-goods.vue?vue&type=script&lang=js&"
export * from "./wxyuceReport-goods.vue?vue&type=script&lang=js&"
import style0 from "./wxyuceReport-goods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports